/**
 * Transaction Rejection Reasons
 * Para işlemlerinde red sebebi seçenekleri
 *
 * Bu dosyayı düzenleyerek tüm red sebeplerinizi tek yerden yönetebilirsiniz.
 */

export const REJECTION_REASONS = [
  "Kredi parasından dolayı red",
  "Hisse parasından dolayı red",
  "Müşteri onay vermedi",
  "Müşteri bankalar arası parayı çevirerek gönderdi",
  "Açıklamadan dolayı iade",
  "Alıcı adı hatalı",
  "musteri bankasi bloke"
];

export default REJECTION_REASONS;
